import { RMR_INDIGO } from "@/styles/tokens";

const mergeContentClass = (existingClass, className) => {
  if (!existingClass) {
    return className;
  }

  if (Array.isArray(existingClass)) {
    return [...existingClass, className];
  }

  return `${existingClass} ${className}`;
};

export const buildRmrChoiceFieldAttrs = (attrs) => {
  const nextAttrs = { ...attrs };
  const menuProps = nextAttrs.menuProps || nextAttrs["menu-props"] || {};

  delete nextAttrs.menuProps;
  delete nextAttrs["menu-props"];

  return {
    color: RMR_INDIGO,
    itemColor: RMR_INDIGO,
    ...nextAttrs,
    menuProps: {
      ...menuProps,
      contentClass: mergeContentClass(menuProps.contentClass, "rmr-input-menu"),
    },
  };
};

export const rmrChoiceFieldComputed = {
  fieldAttrs() {
    return buildRmrChoiceFieldAttrs(this.$attrs);
  },
  listeners() {
    return {
      ...this.$listeners,
      input: (value) => this.$emit("input", value),
      change: (value) => this.$emit("change", value),
    };
  },
};
